// Module Import
//---------------------------------
import 'slick-carousel/slick/slick.scss'
import '../../../assets/css/slick-theme.scss'

import React from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import Image from '../../atoms/images/images'
import ImageCut from '../../../assets/images/graphic_imageCut.svg'

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const GalleryCarouselWrapper = styled.div`
  border-radius: 4px;
  position: relative;

  &:after {
    background-image: url(${ImageCut});
    background-repeat: no-repeat;
    background-size: 100%;
    bottom: 0;
    content: '';
    height: 30px;
    position: absolute;
    right: 0;
    width: 30px;
    z-index: 1;
  }

  @media only screen and (min-width: 48em) {
    &:after {
      background-image: url(${ImageCut});
      background-position: bottom right;
      background-size: cover;
      bottom: 0;
      content: '';
      height: 60px;
      position: absolute;
      right: 0;
      width: 60px;
      z-index: 1;
    }
  }
`

// Component Export
//---------------------------------
export default function GalleryCarousel({ carouselImages }) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    fade: true,
    autoplaySpeed: 4000,
    adaptiveHeight: true,
  }

  return (
    <GalleryCarouselWrapper>
      <Slider {...settings}>
        {carouselImages.map((target, index) => (
          <div key={index}>
            <Image
              imgSrc={target.gatsbyImageData}
              altTag={target.imgAltTag}
              hasFrame="No Frame"
              aspectRatio="None"
            />
          </div>
        ))}
      </Slider>
    </GalleryCarouselWrapper>
  )
}

GalleryCarousel.propTypes = {}
